import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ 
  element: Component, 
  requiredPermissions = [], 
  redirectPath = '/login' 
}) => {
  const { isAuthenticated, checkMultiplePermissions, loading } = useAuth();

  // Wait for authentication check to complete before making routing decisions
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Laster...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  if (requiredPermissions.length > 0 && !checkMultiplePermissions(requiredPermissions)) {
    return <Navigate to="/dashboard" replace />;
  }

  return Component;
};